<template>
    <a class="uik-widget-bottom-cta__wrapper">
        <slot></slot>
    </a>
</template>

<script>
export default {
    name: "UikWidgetBottomCta"
}
</script>

<style lang="scss">
.uik-widget-bottom-cta__wrapper {
  height: 50px;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $textSecondary;
  text-transform: uppercase;
  font-size: .75rem;
  font-weight: 500;
  border-top: $borderDefault;
  &:hover {
    color: $textMain;
  }
}
</style>
